import { Button, Col, Form, Row, Select, Upload, notification } from "antd";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import { UploadOutlined } from "@ant-design/icons";

const AddMaterialUsageByMix = ({ onSuccess }) => {
	const [form] = Form.useForm();
	const [plantOptions, setPlantOptions] = useState([]);
	const [subplantOptions, setSublantOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const [loadingSubplant, setLoadingSubplant] = useState(true);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getPlant();
	}, []);

	const getPlant = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let plantList = [];
			data.payload.map((item) => {
				plantList.push({
					label: item.name,
					value: item._id,
				});
			});
			setPlantOptions(plantList);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getSublant = async (currentPlant) => {
		const url = api + `/plant/${currentPlant}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let subplantList = [];
			data.subplants.map((item) => {
				subplantList.push({
					label: item.name,
					value: item.name,
				});
			});
			setSublantOptions(subplantList);
			setLoadingSubplant(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const onFinish = async (values) => {
		try {
			setLoading(true);
			const url = api + "/files/create/materialusage";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const config = {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};
			const formData = new FormData();

			if (values.materialUsageFile && values.materialUsageFile.length > 0) {
				formData.append(
					"materialUsageFile",
					values.materialUsageFile[0].originFileObj
				);
			}

			formData.append("plant", values.plant);
			formData.append("subplant", values.subplant);

			const { data } = await axios.post(url, formData, config);

			if (data.success) {
				openNotification("success", "Success", data.message);
				setTimeout(() => {
					setLoading(false);
					onSuccess();
				}, 2000);
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to upload form");
			console.error(err.message);
			return null;
		}
	};

	const onChangePlant = (value) => {
		form.setFieldsValue({ subplant: "" });
		setLoadingSubplant(true);
		getSublant(value);
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const normFile = (e) => {
		if (Array.isArray(e)) {
			return e;
		}
		return e?.fileList;
	};

	const CustomForm = () => {
		return (
			<Form form={form} layout="vertical" onFinish={onFinish}>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Plant"
							name="plant"
							rules={[
								{
									required: true,
									message: "Please select a plant",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select plant`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={plantOptions}
								onChange={onChangePlant}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Subplant"
							name="subplant"
							rules={[
								{
									required: true,
									message: "Please select a subplant",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select subplant`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={subplantOptions}
								disabled={loadingSubplant}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item
							label="Evidence"
							name="materialUsageFile"
							valuePropName="fileList"
							getValueFromEvent={normFile}
							rules={[
								{
									required: true,
									message: "Evidence is required",
								},
							]}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={1}
								multiple={false}
								accept=".xlsx, .xls"
							>
								<Button
									icon={<UploadOutlined />}
									size="large"
									style={{
										width: "100%",
									}}
									type="default"
								>
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col>
						<Button
							type="primary"
							htmlType="submit"
							loading={loading}
							size="large"
						>
							Save
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<div>
			{contextHolder}
			<CustomForm />
		</div>
	);
};

export default AddMaterialUsageByMix;
